<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />
    <example-title src="example-1.html" title="Application scenarios" />
    <vc-layout :spacing="8" :class="['align-center']">
      <vc-col :span="6" xs24>
        <h4 :class="configHeading">Text badges</h4>
        <vc-badge @click="onClick">1</vc-badge>
        <vc-badge @click="onClick" color="red">10</vc-badge>
        <vc-badge @click="onClick" color="deep-purple">123</vc-badge>
      </vc-col>
      <vc-col :span="6" xs24>
        <h4 :class="configHeading">Badges with icons</h4>
        <vc-badge @click="onClick">
          <vc-icon size="small">home</vc-icon>
        </vc-badge>
        <vc-badge @click="onClick" color="warning" :dark="false">
          <vc-icon size="small">info_outline</vc-icon>
        </vc-badge>
        <vc-badge @click="onClick" color="green">
          <vc-icon size="small">notifications</vc-icon>
        </vc-badge>
        <vc-badge @click="onClick">
          <vc-icon size="small">mdi-account</vc-icon>
        </vc-badge>
      </vc-col>
      <vc-col :span="6" xs24>
        <h4 :class="configHeading">Badges in buttons</h4>
        <vc-button color="green">
          Button <vc-badge @click="onClick" color="red">12</vc-badge>
        </vc-button>
        <br /><br />
        <vc-button color="orange">
          <vc-badge color="deep-purple">
            <vc-icon @click="onClick" size="small">home</vc-icon>
          </vc-badge> Button
        </vc-button>
      </vc-col>
      <vc-col :span="6" xs24>
        <h4 :class="configHeading">Shopping cart</h4>
        <vc-icon size="large">shopping_cart</vc-icon> <vc-badge @click="onClick" color="red" style="margin-top: -24px">1</vc-badge>
      </vc-col>
    </vc-layout>
    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'BadgePage',
  data () {
    return {
      title: null,
      description: null,
      configHeading: ['subheading', 'font-grey', 'font-l-600', 'mx-0', 'my-16']
    }
  },
  mixins: [
    methods
  ],
  mounted () {
    this.getPage()
  },
  methods: {
    onClick () {
      console.log('vc-badge:click')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/badge.vue